var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', _vm._l(_vm.links, function (link, i) {
    return _c('v-list-item', {
      key: i,
      staticClass: "v-list-item",
      attrs: {
        "to": link.to
      }
    }, [_c('v-list-item-action', [_c('IconCustom', {
      attrs: {
        "name": link.icon
      }
    })], 1), _c('v-list-item-title', [_vm._v(_vm._s(link.text))])], 1);
  }), 1);

}
var staticRenderFns = []

export { render, staticRenderFns }